var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import FormAlerts from './FormAlerts';
var CordataForm = function CordataForm(_ref) {
  var children = _ref.children,
    formAlertsProps = _ref.formAlertsProps,
    validateOnBlur = _ref.validateOnBlur,
    validateOnChange = _ref.validateOnChange,
    props = _objectWithoutProperties(_ref, ['children', 'formAlertsProps', 'validateOnBlur', 'validateOnChange']);
  return React.createElement(Formik, _extends({}, props, {
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange
  }), function (renderProps) {
    return React.createElement(Form, {
      noValidate: true
    }, renderProps.submitCount >= 1 && renderProps.errors && React.createElement(FormAlerts, _extends({
      errors: renderProps.errors
    }, formAlertsProps)), children(renderProps));
  });
};
CordataForm.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.func]).isRequired,
  formAlertsProps: PropTypes.shape({
    validationMessage: PropTypes.string,
    serverMessage: PropTypes.string,
    loginMessage: PropTypes.string,
    login: PropTypes.bool
  }),
  validateOnBlur: PropTypes.bool,
  validateOnChange: PropTypes.bool
};
CordataForm.defaultProps = {
  formAlertsProps: {
    validationMessage: undefined,
    serverMessage: undefined,
    loginMessage: undefined,
    login: undefined
  },
  validateOnBlur: false,
  validateOnChange: false
};
export default CordataForm;